import { render, staticRenderFns } from "./LpuMedalDialog.vue?vue&type=template&id=7cb18ae6&scoped=true&"
import script from "./LpuMedalDialog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuMedalDialog.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuMedalDialog.vue?vue&type=style&index=0&id=7cb18ae6&lang=scss&"
import style1 from "./LpuMedalDialog.vue?vue&type=style&index=1&id=7cb18ae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb18ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cb18ae6')) {
      api.createRecord('7cb18ae6', component.options)
    } else {
      api.reload('7cb18ae6', component.options)
    }
    module.hot.accept("./LpuMedalDialog.vue?vue&type=template&id=7cb18ae6&scoped=true&", function () {
      api.rerender('7cb18ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuMedals/components/LpuMedalDialog.vue"
export default component.exports